import { useQuery } from '@tanstack/react-query';

/**
 * Painel antigo do Metabase filtrado pela campanha (dashboard 133 em loja com
 * pontos, 55 nas outras), assinado pela BFF. A URL vale 10 minutos: ao voltar
 * para a aba depois de 5, busca outra em vez de reusar a do cache.
 */
export function useCampaignMetabaseEmbed(idPassbook: string, campaignId: string | undefined, enabled: boolean) {
  return useQuery({
    queryKey: ['campaign-results', 'metabase', idPassbook, campaignId],
    queryFn: async (): Promise<{ iframeUrl: string }> => {
      const res = await fetch(`/bff/metabase/campaign/${idPassbook}/${campaignId}`, {
        credentials: 'same-origin',
      });
      if (!res.ok) {
        const body = (await res.json().catch(() => ({}))) as { message?: string };
        throw new Error(body.message ?? 'Metabase indisponível');
      }
      return res.json() as Promise<{ iframeUrl: string }>;
    },
    enabled: enabled && Boolean(idPassbook && campaignId),
    staleTime: 5 * 60_000,
    refetchOnMount: true,
    retry: 1,
  });
}
